 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~activity~fileOverlay-FileOver~e4fa4edd","1":"vendors~CurationUploaderAdd~CurationUploaderEdit~NationBuilderPreferencesPage~Uploader-DesignUploade~115101c3","2":"vendors~activity~components-YourLevelPage~fileOverlay-FileOverlay~files~pages-auth-PageContainer~pag~e59e887f","3":"vendors~CurationUploaderAdd~CurationUploaderEdit~Uploader-DesignUploaderOverlayAdd~Uploader-DesignUp~34633c89","4":"FacebookAdPreferences~SquarePreferences~SquarespacePreferences~overview~pages-browse-projects-Browse~92bbe252","5":"vendors~CurationUploaderAdd~Uploader-DesignUploaderOverlayAdd~activity~components-ProfilePage~files~~5658d979","6":"FacebookAdPreferences~NationBuilderPreferencesPage~PreziPreferences~SquarePreferences~SquarespacePreferences","7":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~35dff39e","8":"vendors~CurationUploaderAdd~CurationUploaderEdit~Uploader-DesignUploaderOverlayAdd~Uploader-DesignUp~75916984","9":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~6457156e","10":"vendors~components-PortfolioPage~components-ProfessionalBackgroundPage~pages-create~payments","11":"FacebookAdPreferences~SquarePreferences~SquarespacePreferences","12":"activity~fileOverlay-FileOverlay~files","13":"vendors~99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers~p~adbd859c","14":"CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","15":"PasswordStrengthBar","16":"components-PersonalInformationPage~components-ProfessionalBackgroundPage","17":"pages-account~pages-getting-started","18":"pages-projects-ProjectsApp~pages-projects-invoices-ProjectInvoicePage","19":"vendors~PasswordStrengthBar","20":"vendors~pages-designer-onboarding-DesignerOnboarderPage~pages-web-get-started-WebOnboarderPage","21":"vendors~pages-handover-messages~pages-messages","22":"vendors~pages-handover-messages~pages-projects-ProjectsApp","23":"99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","24":"CurationUploaderAdd","25":"CurationUploaderEdit","26":"FacebookAdPreferences","27":"NationBuilderPreferencesPage","28":"PreziPreferences","29":"SquarePreferences","30":"SquarespacePreferences","31":"Uploader-DesignUploaderOverlayAdd","32":"Uploader-DesignUploaderOverlayEdit","33":"activity","34":"components-CurationSamplesPage-CurationSamplesPage","35":"components-LogInMethodPage","36":"components-NotificationsPage","37":"components-PersonalInformationPage","38":"components-PortfolioPage","39":"components-ProfessionalBackgroundPage","40":"components-ProfilePage","41":"components-TermsPage","42":"components-VerificationPage","43":"components-YourLevelPage","44":"design-transfer-agreement","45":"fileOverlay-FileOverlay","46":"files","48":"overview","49":"pages-account","50":"pages-admin-redirects","51":"pages-auth-PageContainer","52":"pages-auth-VerifyTwoFactor-VerifyAddPayout","53":"pages-browse-projects-BrowseProjects","54":"pages-create","55":"pages-designer-onboarding-DesignerOnboarderPage","56":"pages-getting-started","57":"pages-handover-messages","58":"pages-messages","59":"pages-notifications","60":"pages-onboarder-OnboarderPage","61":"pages-projects-ProjectsApp","62":"pages-projects-cancel-invites","63":"pages-projects-invoices-ProjectInvoicePage","64":"pages-status","65":"pages-web-get-started-WebOnboarderPage","66":"pages-your-work-YourWorkApp","67":"payments","69":"vendors~PreziPreferences","70":"vendors~components-PortfolioPage","71":"vendors~components-ProfilePage","72":"vendors~fileOverlay-FileOverlay","73":"vendors~pages-admin-redirects","74":"vendors~pages-browse-projects-BrowseProjects","75":"vendors~pages-your-work-YourWorkApp"}[chunkId]||chunkId) + "." + {"0":"e9131a8963","1":"6727601389","2":"4f58605c70","3":"453e3f91fe","4":"a08178816a","5":"fc57b9ac75","6":"bb567168df","7":"d2de440846","8":"e1ecdebf78","9":"4cc00388e7","10":"22792760e6","11":"5ddc9f79e6","12":"b38fbb4e35","13":"c2768cdee9","14":"d2b4cabc55","15":"70393ed5ef","16":"7f1b229cea","17":"c9fb195a43","18":"1dfe4f4332","19":"3e06251faa","20":"fe0427904e","21":"ea2d3ee359","22":"d5151934ac","23":"cdbc87bc3e","24":"3bbc2ad5cb","25":"30c044ead7","26":"edccd630ea","27":"08a2e2ce08","28":"35cc9184f6","29":"57ed548c27","30":"a9dfccc7b2","31":"0e0dc0edca","32":"49ea21ddce","33":"2576915de5","34":"ae210076d5","35":"f9004bfdb9","36":"c82def207e","37":"c0de8d6933","38":"e48e23ffac","39":"1d49af0ead","40":"6774c6e786","41":"c8898e2112","42":"d98312b887","43":"8cc8f927e2","44":"533340cc08","45":"4aa7e22f49","46":"0e36d8155e","48":"c8b5faf25a","49":"9d81ee854f","50":"8cc347b3b0","51":"c201e6d041","52":"80e6b4a549","53":"525fedb4d7","54":"9663115a6f","55":"86ea2848c8","56":"7b72e21e7f","57":"c180e82991","58":"d49e392120","59":"15926d6cf2","60":"2c266f1eb2","61":"a1f028fe22","62":"40e839b5f9","63":"42b095607d","64":"b62997aecf","65":"5a6895cbf5","66":"2b881f9db4","67":"f60cd2b62a","69":"90ea1c828f","70":"251b72fd0a","71":"25283ac08b","72":"fdde28b135","73":"058f73d541","74":"279ce79cba","75":"080a0d0476","76":"4aeade0975","77":"bab2571694","78":"43ad5ca630","79":"ee739faf2d"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/pt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 327);
